import { render, staticRenderFns } from "./format.vue?vue&type=template&id=feb47136&"
import script from "./format.vue?vue&type=script&lang=js&"
export * from "./format.vue?vue&type=script&lang=js&"
import style0 from "./format.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "format.vue"
export default component.exports